import { useGetCountriesQuery } from '@/store/apis/carriers/carrierApiCalls';
import { useAuthenticator } from '@aws-amplify/ui-react';
import type { Nullable } from 'primereact/ts-helpers';
import { useEffect, useState } from 'react';

export function useSearchCountry() {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  const state = useGetCountriesQuery('', {
    skip: authStatus !== 'authenticated',
  });
  const [countryMap, setCountryMap] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    const map: { [key: string]: string } = {};
    state.data?.data?.forEach((con) => {
      map[con.code] = con.name;
    });
    setCountryMap(map);
  }, [state.data?.data]);

  function searchByCode(code: Nullable<string>) {
    if (!code) return;
    return state.data?.data?.find((item) =>
      item.code.toLowerCase().includes(code.toLowerCase()),
    );
  }

  return { searchByCode, countryMap };
}
